module.exports = __webpack_public_path__ + "img/rep.bea8f044.svg";